<template>
  <el-card>
    <el-page-header @back="$router.back()" slot="header" content="Create Credit Application Invite" />

    <el-form label-position="top" :model="form" :rules="rules" :disabled="loading" ref="inviteForm">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Language" prop="language">
            <el-select v-model="form.language" placeholder="Select Language">
              <el-option
                v-for="lang in languages"
                :key="lang.value"
                :label="lang.label"
                :value="lang.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Customer Email" prop="customer_email">
            <el-input v-model="form.customer_email" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="Rep Name" prop="rep_name">
            <el-input v-model="form.rep_name" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Rep Email" prop="rep_email">
            <el-input v-model="form.rep_email" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item>
            <el-button type="primary" @click="submit">Send Application Invite Email</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>

<script>
import axios, { RepositoryError } from "../../repositories";
import { notify } from "../../utils";

export default {
  name: "CreateApplicationInvite",
  data() {
    return {
      form: {
        language: "en",
        customer_email: "",
        rep_name: "",
        rep_email: "",
      },
      loading: false,
    };
  },
  computed: {
    languages: () => [
      {label: 'English', value: 'en'},
      {label: 'French', value: 'fr'},
    ],
    rules: () => ({
      language: [
        { required: true, message: 'Please input language', trigger: 'blur' },
      ],
      customer_email: [
        { required: true, message: 'Email address is invalid', trigger: 'blur' },
        { type: 'email', message: 'Please correct customer email address', trigger: 'blur' },
      ],
      rep_name: [
        { required: true, message: 'Please input rep name', trigger: 'blur' },
      ],
      rep_email: [
        { required: true, message: 'Please input rep email', trigger: 'blur' },
        { type: 'email', message: 'Email address is invalid', trigger: 'blur' },
      ],
    }),
  },
  methods: {
    submit() {
      this.$refs.inviteForm.validate(valid => {
        if (!valid) {
          return false;
        }

        this.create();
      });
    },
    async create() {
      try {
        this.loading = true;

        await axios.post("/credit-dashboard/access-tokens", {
          customer_email: this.form.customer_email,
          rep_name: this.form.rep_name,
          rep_email: this.form.rep_email,
          language: this.form.language,
        });

        notify(
          `Successfully invited ${this.form.customer_email} to fill out a credit application!`,
          "success"
        );

        this.$router.push({ name: "credit-dashboard" });
      } catch (err) {
        if (err instanceof RepositoryError) {
          return;
        }
        
        throw err;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
